// Role Permission action types
export const FETCH_ROLE_PERMISSIONS_REQUEST = 'rolePermissions/FETCH_ROLE_PERMISSIONS_REQUEST';
export const FETCH_ROLE_PERMISSIONS_SUCCESS = 'rolePermissions/FETCH_ROLE_PERMISSIONS_SUCCESS';
export const FETCH_ROLE_PERMISSIONS_FAILURE = 'rolePermissions/FETCH_ROLE_PERMISSIONS_FAILURE';
export const SAVE_ROLE_PERMISSIONS_REQUEST = 'rolePermissions/SAVE_ROLE_PERMISSIONS_REQUEST';
export const SAVE_ROLE_PERMISSIONS_SUCCESS = 'rolePermissions/SAVE_ROLE_PERMISSIONS_SUCCESS';
export const SAVE_ROLE_PERMISSIONS_FAILURE = 'rolePermissions/SAVE_ROLE_PERMISSIONS_FAILURE';